import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: Urdu helpline mirrors.
export const Route = createFileRoute("/ur/helpline/$")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
